import { AnalyticsEvents } from '../types/events'
import { isElementClickLike } from '../tracking/event-policy'
import { resolvePendoActionSubAction } from '../tracking/pendo-action-policy'
import { buildTrackedRoute, PAGE_HIT, resolveAppType, resolveEventTypes } from '../utils/page-hit'
import { clientPortalAnalyticsService } from '../services/clientportal-analytics.service'
import type { AnalyticsEventProperties } from '../types/properties'
import type { AnalyticsProvider } from './base.provider'

// Formats service-selected events into `/track/events` payloads for the Pendo endpoint.
export class PendoAnalyticsProvider implements AnalyticsProvider {
  name = 'PendoAnalytics'

  constructor(private readonly flavor: string) {}

  track(wireEvent: string, properties?: Record<string, unknown>): void {
    const enrichedProperties = (properties ?? {}) as AnalyticsEventProperties
    const path = (enrichedProperties.pagePath as string) ?? ''
    const locationId = enrichedProperties.locationId as string | undefined
    if (!path || !locationId) return

    const contactId = enrichedProperties.contactId as string | undefined
    const userId = enrichedProperties.userId as string | undefined
    const routeName = enrichedProperties.routeName as string | undefined
    const route = buildTrackedRoute(path, enrichedProperties.activeTab as string | undefined)
    const appType = resolveAppType(route, routeName, this.flavor)
    const { action, sub_action } = resolvePendoActionSubAction(wireEvent, enrichedProperties)

    const baseHit = {
      locationId,
      path: route,
      flavor: this.flavor,
      appType,
      action,
      sub_action,
      contactId,
      userId,
    }

    if (wireEvent === AnalyticsEvents.PAGE_VIEW) {
      for (const eventType of resolveEventTypes(path, routeName, this.flavor === 'gokollab')) {
        const payload = { eventType, ...baseHit }
        clientPortalAnalyticsService.trackPageHit(payload)
      }
      return
    }

    const pendoProperties = enrichedProperties.pendoProperties
    const eventType =
      wireEvent === AnalyticsEvents.ELEMENT_CLICKED || wireEvent === AnalyticsEvents.NAVIGATION_CLICKED || isElementClickLike(wireEvent)
        ? PAGE_HIT.CLIENTPORTAL
        : wireEvent
    const payload = { eventType, ...baseHit, ...(pendoProperties ? { extraProperties: pendoProperties } : {}) }
    clientPortalAnalyticsService.trackPageHit(payload)
  }
}
